import { useDispatch, useSelector } from 'react-redux'
import { RootState } from '../redux/store'
import { getWorkOrderStatesActionAsync } from '../redux/actions/workOrderStateActions'

export const useWorkOrderState = () => {
  const { workOrderStatesState } = useSelector(
    (state: RootState) => state.workOrderState
  )
  const dispatch = useDispatch()

  const getWorkOrderStates = () => {
    dispatch(getWorkOrderStatesActionAsync())
  }

  return { workOrderStatesState, getWorkOrderStates }
}
